export default {"src":"/_next/static/media/truck-icon-1.f8247779.svg","height":19,"width":16,"blurWidth":0,"blurHeight":0};